import { Box } from "@mui/material";
import Label from "../components/atoms/Label";
import React from "react";
import ic_questions from "../assets/ic_questions.svg";
import ic_test_structure from "../assets/test_structure.svg";
import { useNavigate } from "react-router-dom";

const TestInstructions = () => {
	const navigate = useNavigate();
	return (
		<Box
			sx={{
				width: "100%",
				minHeight: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" },
				backgroundColor: "rgba(0, 0, 0, 0.5)",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				padding: "20px",
			}}>
			<div
				style={{
					backgroundColor: "white",
					borderRadius: "6px",
					padding: "40px",
					maxWidth: "555px",
					width: "100%",
					boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
				}}>
				<div
					style={{
						display: "flex",
						gap: "30px",
						marginBottom: "30px",
						alignItems: "flex-start",
					}}>
					<img
						src={ic_test_structure}
						alt='pencil'
						style={{ width: "57px", height: "57px" }}
					/>

					<div
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "flex-start",
							gap: "15px",
						}}>
						<Label
							label='Test Structure'
							fontSize='20px'
							fontWeight='400'
							color='#000000'
							textAlign='left'
							margin='0px'
							padding='0px'
						/>
						<Label
							label='This test is timed and structured like the actual digital SAT, but you can save and exit the test anytime'
							fontSize='16px'
							fontWeight='400'
							color='#000000'
							textAlign='left'
							margin='0px'
							padding='0px'
						/>
					</div>
				</div>

				<div
					style={{
						display: "flex",
						gap: "30px",
						marginBottom: "30px",
						alignItems: "flex-start",
					}}>
					<img
						src={ic_questions}
						alt='pencil'
						style={{ width: "57px", height: "57px" }}
					/>

					<div
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "flex-start",
							gap: "15px",
						}}>
						<Label
							label='Questions'
							fontSize='20px'
							fontWeight='400'
							color='#000000'
							textAlign='left'
							margin='0px'
							padding='0px'
						/>
						<Label
							label='Some questions contain facts, names, research findings, and artworks that are created solely for the purpose of this test and may not necessarily be accurate.'
							fontSize='16px'
							fontWeight='400'
							color='#000000'
							textAlign='left'
							margin='0px'
							padding='0px'
						/>
					</div>
				</div>

				<div
					style={{
						display: "flex",
						gap: "30px",
						marginBottom: "40px",
						alignItems: "flex-start",
					}}>
					<img
						src={ic_questions}
						alt='pencil'
						style={{ width: "57px", height: "57px" }}
					/>

					<div
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "flex-start",
							gap: "15px",
						}}>
						<Label
							label='Adaptive Testing'
							fontSize='20px'
							fontWeight='400'
							color='#000000'
							textAlign='left'
							margin='0px'
							padding='0px'
						/>
						<Label
							label='Similar to the actual test your performance in the first module of each section will determine the difficulty level of the second module.'
							fontSize='16px'
							fontWeight='400'
							color='#000000'
							textAlign='left'
							margin='0px'
							padding='0px'
						/>
					</div>
				</div>

				<div style={{ textAlign: "center" }}>
					<Label
						label='Good Luck! 😊'
						fontSize='16px'
						fontWeight='700'
						color='#000000'
						textAlign='left'
						padding='0px'
					/>
					<button
						style={{
							backgroundColor: "#1F21E6",
							color: "white",
							padding: "12px 0",
							border: "none",
							borderRadius: "4px",
							fontSize: "16px",
							cursor: "pointer",
							width: "100%",
							marginTop: "20px",
						}}
						onClick={() => {
							navigate("/exam-interface");
						}}>
						Start
					</button>
				</div>
			</div>
		</Box>
	);
};

export default TestInstructions;
